export default __webpack_public_path__ + "static/media/status-yellow.53b71b38.svg";